import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { deleteSubscription } from "../Services/subscriptionService";

export const useDeleteSubscription = ({ onSuccess, onError } = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ subscriptionType, userType }) =>
            deleteSubscription(subscriptionType, userType),
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries(["subscriptions"]);
            toast.success("Subscription deleted successfully");
            if (onSuccess) onSuccess(data, variables, context);
        },
        onError: (error, variables, context) => {
            toast.error(error?.response?.data?.status?.message ?? "Failed to delete subscription");
            if (onError) onError(error, variables, context);
        },
    });
};

